import {EOrderPaymentStatuses, EOrderStatuses, IOrder} from "@/model/Order/orderInterfaces";

export class OrderHelper {

  private static readonly paidStatuses = [
    EOrderPaymentStatuses.status_payment_paid,
    EOrderPaymentStatuses.status_payment_paid_invoice,
  ];

  public static readonly closedStatuses = [
    EOrderStatuses.status_order_completed,
    EOrderStatuses.status_order_sp_cancelled,
    EOrderStatuses.status_order_client_cancelled,
    EOrderStatuses.status_order_sp_rejected,
  ];

  public static canFinalize(order: IOrder): boolean {
    const excludedStatuses = [
      EOrderStatuses.status_order_completed,
      EOrderStatuses.status_order_client_cancelled,
      EOrderStatuses.status_order_sp_cancelled,
    ];
    return !excludedStatuses.includes(order.status);
  }

  public static canProcess(order: IOrder): boolean {
    const statuses: string[] = [
      EOrderStatuses.status_order_sp_collected,
      EOrderStatuses.status_order_in_progress,
      EOrderStatuses.status_order_in_route_delivery,
      // EOrderStatuses.status_order_completed,
      EOrderStatuses.status_order_sp_delivered,
    ];
    return order.locked &&
      (statuses.indexOf(order.status) !== -1);
  }

  public static canConfirm(order: IOrder): boolean {
    const cannotConfirmStatuses = [
      EOrderStatuses.status_order_new,
      EOrderStatuses.status_order_awaiting_customer_dropoff,
      // EOrderStatuses.status_order_awaiting_collect,
      // we shouldn't get to completed without confirmation, but who knows :D
      EOrderStatuses.status_order_completed,
    ];
    return !cannotConfirmStatuses.includes(order.status) && !order.locked;
  }

  public static canPay(order: IOrder): boolean {
    return !OrderHelper.paidStatuses.includes(order.payment_status) &&
      !OrderHelper.closedStatuses.includes(order.status);
  }

  public static canRequestPickup(order: IOrder): boolean {
    return order.status === EOrderStatuses.status_order_new &&
      order.services.length > 0 &&
      !!order.pickupLocation &&
      order.pickupLocation.type === 'locker';
  }

  public static isPaid(order: IOrder): boolean {
    return OrderHelper.paidStatuses.includes(order.payment_status);
  }

}
